import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "sidebar-header" }
const _hoisted_3 = { class: "main-menu" }
const _hoisted_4 = { class: "sub-menu" }
const _hoisted_5 = { class: "sub-menu" }
const _hoisted_6 = { class: "sub-menu" }
const _hoisted_7 = { class: "sub-menu" }
const _hoisted_8 = { class: "sub-menu" }
const _hoisted_9 = { class: "sub-menu" }
const _hoisted_10 = { class: "main" }

import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'adminSidebar',
  setup(__props) {

const route = useRoute()
    
const handleMouseOver = (e: MouseEvent) => {
  const subMenu = (e.currentTarget as HTMLElement).querySelector('.sub-menu')
  if (subMenu) subMenu.classList.add('active')
}

const handleMouseOut = (e: MouseEvent) => {
  const subMenu = (e.currentTarget as HTMLElement).querySelector('.sub-menu')
  if (subMenu && !subMenu.querySelector('a.current')) {
    subMenu.classList.remove('active')
  }
}

const updateCurrentMenu = () => {
  const currentUrl = route.path
  const menuLinks = document.querySelectorAll('.sub-menu a')
  menuLinks.forEach((link) => {
    const el = link as HTMLAnchorElement
    if (el.getAttribute('href') === currentUrl) {
      el.classList.add('current')
      el.closest('.sub-menu')?.classList.add('active')
    } else {
      el.classList.remove('current')
    }
  })
}

onMounted(updateCurrentMenu)
watch(() => route.path, updateCurrentMenu)


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_RouterLink, { to: "/admin/schedule" }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("h2", null, "관리", -1)
          ])),
          _: 1,
          __: [0]
        })
      ]),
      _createElementVNode("nav", null, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", {
            onMouseover: handleMouseOver,
            onMouseout: handleMouseOut
          }, [
            _cache[2] || (_cache[2] = _createElementVNode("h3", null, "일정", -1)),
            _createElementVNode("ul", _hoisted_4, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, { to: "/admin/plan" }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode(" 일정 목록 ")
                  ])),
                  _: 1,
                  __: [1]
                })
              ])
            ])
          ], 32),
          _createElementVNode("li", {
            onMouseover: handleMouseOver,
            onMouseout: handleMouseOut
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("h3", null, "이미지 관리", -1)),
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, { to: "/admin/imageList" }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode(" 이미지 목록 ")
                  ])),
                  _: 1,
                  __: [3]
                })
              ])
            ])
          ], 32),
          _createElementVNode("li", {
            onMouseover: handleMouseOver,
            onMouseout: handleMouseOut
          }, [
            _cache[6] || (_cache[6] = _createElementVNode("h3", null, "사용자 현황", -1)),
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, { to: "/admin/todayChart" }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode(" 사용자 현황 ")
                  ])),
                  _: 1,
                  __: [5]
                })
              ])
            ])
          ], 32),
          _createElementVNode("li", {
            onMouseover: handleMouseOver,
            onMouseout: handleMouseOut
          }, [
            _cache[8] || (_cache[8] = _createElementVNode("h3", null, "공지사항", -1)),
            _createElementVNode("ul", _hoisted_7, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, { to: "/admin/noticeList" }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode(" 공지사항 목록 ")
                  ])),
                  _: 1,
                  __: [7]
                })
              ])
            ])
          ], 32),
          _createElementVNode("li", {
            onMouseover: handleMouseOver,
            onMouseout: handleMouseOut
          }, [
            _cache[10] || (_cache[10] = _createElementVNode("h3", null, "프로필 관리", -1)),
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, { to: "/admin/profileList" }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode(" 프로필 설정 ")
                  ])),
                  _: 1,
                  __: [9]
                })
              ])
            ])
          ], 32),
          _createElementVNode("li", {
            onMouseover: handleMouseOver,
            onMouseout: handleMouseOut
          }, [
            _cache[12] || (_cache[12] = _createElementVNode("h3", null, "달력 관리", -1)),
            _createElementVNode("ul", _hoisted_9, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, { to: "/admin/calendarList" }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode(" 달력 보기 ")
                  ])),
                  _: 1,
                  __: [11]
                })
              ])
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 64))
}
}

})